<template>
  <b-container id="container_progress">
    <div class="progress_bar_container">
                      <b-progress
          :value="(photos_treated/progress.length)*100"
          :label="`${global_progression}test`"
          :max="100"
          variant="success"
          show-progress
          animated
        >
        </b-progress>
    </div>
  <div class="sep"></div>
  <div class="sep"></div>
    <div class="row_item_progress" v-for="(file, index) in progress"
      :key="index">
      <p v-if="file.message"><b-icon icon="x-circle" variant="danger"></b-icon> {{file.filename}} : {{file.message}}</p>
    </div>

  </b-container>
</template>

<script>
export default {
  props: ["progress", "photos_treated"],
  data() {
    return {};
  },
  computed:{
    global_progression(){
      return parseInt(this.photos_treated/this.progress.length)*100;
 
    }
  }
};
</script>

<style lang="scss">
#container_progress {
  .progress_bar_container{
    .progress{
      height:2rem;
      .custom_progress_label{
        color:black;
      }
    }
  }
  p {
    color: white;
  }
  .row_item_progress {
    p{
      text-align:left;
    }
    .col {
      padding-top: 3px;
      padding-bottom: 3px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }

  }
}
</style>